// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__101+S"};